// extracted by mini-css-extract-plugin
export default {"payments_header":"UsersPayments_payments_header__BvOzq","makingPaymentModal":"UsersPayments_makingPaymentModal__Wnc6o"};